import type { Timeframe } from '../data/protocol/types';
import { DEFAULT_MARKET_SYMBOLS } from '../market/instrumentCatalog';

export const APP_NAME = 'Market Terminal';
export const STORAGE_KEY = 'market-terminal.workspace.v5';

export const BREAKPOINTS = {
  lg: 1280,
  md: 996,
  sm: 768,
  xs: 480,
  xxs: 0
};

export const GRID_COLUMNS = {
  lg: 24,
  md: 18,
  sm: 12,
  xs: 8,
  xxs: 4
};

export const GRID_ROW_HEIGHT = 30;
export const GRID_MARGIN: [number, number] = [10, 10];
export const GRID_CONTAINER_PADDING: [number, number] = [10, 10];

export const DEFAULT_SYMBOLS = DEFAULT_MARKET_SYMBOLS;

export const INDEX_SYMBOLS = [
  { symbol: 'SPX', name: 'S&P 500' },
  { symbol: 'NDX', name: 'Nasdaq' },
  { symbol: 'DJI', name: 'Dow' },
  { symbol: 'RUT', name: 'Russell' },
  { symbol: 'BTC', name: 'Bitcoin' },
  { symbol: 'GOLD', name: 'Gold' },
  { symbol: 'OIL', name: 'Oil' }
] as const;

export const DEFAULT_GRAPH_SYMBOL = 'AAPL';
export const DEFAULT_TIMEFRAME: Timeframe = '1m';

export const STREAM_CONFIG = {
  universeSize: 800,
  quoteFlushMs: 33,
  quoteGenerationMs: 8,
  barGenerationMs: 1000,
  newsGenerationMs: 6500,
  maxBatchUpdates: 320,
  quoteBacklogLimit: 960
};

export const MOCK_DATA_URL = `${import.meta.env.BASE_URL}mock/market-data.json`;